export default {
  currency: {
    searchPlaceholder: '请输入币种编号或币种名称查询',
    currencyNo: '币种编号',
    currencyName: '币种名称',
    exchangeRate: '汇率',
    remarks: '备注'
  },
  rate: {
    searchPlaceholder: '请输入税种编号或税种名称查询',
    taxTypeNo: '税种编号',
    taxTypeName: '税种名称',
    taxRateSign: '含税否(Y/N)',
    taxRate: '税率(%)',
    remarks: '备注'
  }
}
